import {
  DefaultConfigType,
  FilteredClientConfigType,
} from '@shared/config/types';
import { filterConfig } from '@shared/config/helpers/filterConfig';

export const initialiseConfig = (utiqHost: string, Utiq: UtiqEnvironment) => {
  const defaultConfig: DefaultConfigType = {
    utiqHost,
    apiPath: '/op/idconnect/consent',
    oncePerSession: false,
    oncePerTimeInterval: null, // Time in MS or null
  };

  /* Initial Utiq.config (here clientConfig) is in an initial tag data set up per client page or via tag manager */
  /* We discard the listeners as they are registered already with registerEventListeners in utiqLoader.js */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { listeners, ...clientConfig } = Utiq.config!;

  const filteredClientConfig: FilteredClientConfigType =
    filterConfig(clientConfig);

  /* Setting of the final config object */
  Utiq.config = {
    ...defaultConfig,
    ...filteredClientConfig,
  };

  /* Set interval for subsequent IdConnect calls */
  Utiq.config.oncePerTimeInterval =
    typeof Utiq.config.oncePerTimeInterval === 'number'
      ? Utiq.config.oncePerTimeInterval
      : 0;
};
